<template>
  <b-form-checkbox
    v-model="_value"
    class="base-switch"
    :name="name"
    switch />
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    name: {
      type: String,
      default: null
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  }
}
</script>

<style lang="scss">
.base-switch {
  margin-bottom: 24px;
  &.custom-control {
    .custom-control-label {
      &::before {
        width: 2.75rem !important;
        height: 1.5rem !important;
        border-radius: 2.5rem !important;
      }

      &::after {
        width: calc(1.5rem - 4px) !important;
        height: calc(1.5rem - 4px) !important;
        border-radius: 1.5rem !important;
      }
    }

    .custom-control-input:checked ~ .custom-control-label {
      background-color: red;
      &::after {
        transform: translateX(1.25rem) !important;
      }
    }
  }
}
</style>